import { styled } from '@mui/material';
import MUICheckbox from '@mui/material/Checkbox';

const Checkbox = styled(MUICheckbox)(() => ({
  padding: 0.3,
  '&.Mui-checked': {
    color: '#000',
  },
}));

export default Checkbox;
